module.exports = __webpack_public_path__ + "static/media/wsymbol_0001_sunny_big_s1.ead4e3af.png";